<template>
  <div>
    <loading
      :active.sync="loading.app"
      :can-cancel="false"
      :is-full-page="true"
      :color="'#0B8BCC'"
      :loader="'dots'"
      :opacity="0.7"
      :lock-scroll="true"
    ></loading>
    <Toast
      :show.sync="toast.show"
      :message="toast.message"
      :tipe="toast.tipe"
      @close="toast.show = false"
      :position="toast.position"
      :icon="toast.icon"
    ></Toast>
    <!-- App Header -->
    <div class="appHeader bg-primary text-light shadow-header-footer">
      <div class="left">
        <router-link
          :to="{
            name: this.previous_page_reference,
            params: this.params_previous_page_reference,
          }"
          class="headerButton"
        >
          <!-- <a href="Javascript:;" class="headerButton" @click="$router.go(-1)"> -->
          <ion-icon name="chevron-back-outline"></ion-icon>
          <!-- </a> -->
        </router-link>
      </div>
      <div class="pageTitle">
        PIN Keamanan
      </div>
    </div>
    <!-- * App Header -->

    <div id="appCapsule">
      <!-- Pilih Metode Pengiriman Kode Verifikasi -->
      <div>
        <div class="section m-2 p-2">
          <div class="text-center">
            <h4>Masukkan Kode PIN</h4>
          </div>
        </div>
        <div class="section mb-5 p-2">
          <div class="pin-container mb-5">
            <input
              ref="pin"
              type="number"
              name="pin-code"
              class="pin-input"
              pattern="\d*"
              maxlength="6"
              inputMode="numeric"
              autocomplete="off"
              v-model="data.pin"
              @input="submitPINVerify()"
              autofocus
            />
          </div>
          <div class="text-center">
            <router-link
              :to="{
                name: 'account.pin',
              }"
              style="font-weight: bold;"
            >
              Lupa Kode PIN?
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import $axios from "../../api.js";
export default {
  name: "auth.pin.verify",
  props: [
    "data_reference",
    "url_reference",
    "previous_page_reference",
    "params_previous_page_reference",
    "next_page_reference",
    "params_next_page_reference",
  ],
  data() {
    return {
      data: {
        data_reference: this.data_reference,
        pin: "",
      },
    };
  },
  created() {
    setTimeout(() => {
      this.$store.commit("SET_LOADING", { app: false });
    }, 500);
  },
  computed: {
    ...mapState(["loading", "toast"]),
  },
  methods: {
    submitPINVerify() {
      if (this.data.pin.length == 6) {
        this.$store.commit("SET_LOADING", { app: true });
        $axios
          .post(this.url_reference, { data: btoa(JSON.stringify(this.data)) })
          .then((response) => {
            this.$store.commit("SET_LOADING", { app: false });
            this.$router.push({
              name: this.next_page_reference,
              params: Object.assign({}, this.params_next_page_reference, {
                toast_reference: {
                  show: true,
                  message: response.data.message,
                  tipe: "default",
                  icon: "success",
                },
              }),
            });
          })
          .catch((error) => {
            this.$store.commit("SET_LOADING", { app: false });
            if (error.response.data.code == "VALIDATE_PIN_FAIL") {
              this.$store.commit("SET_TOAST", {
                show: true,
                message: error.response.data.message,
                tipe: "default",
                icon: "danger",
              });
            } else {
              this.$router.push({
                name: this.previous_page_reference,
                params: Object.assign({}, this.params_previous_page_reference, {
                  toast_reference: {
                    show: true,
                    message: error.response.data.message,
                    tipe: "default",
                    icon: "danger",
                  },
                }),
              });
            }
          });
      }
    },
  },
  mounted() {
    this.$refs.pin.focus();
    if (
      this.data_reference == undefined ||
      this.url_reference == undefined ||
      this.previous_page_reference == undefined ||
      this.next_page_reference == undefined
    ) {
      this.$router.go(-1);
    }
    // console.log();
    // document.body.classList.add("bg-white");
  },
  destroyed() {
    this.$store.commit("RESET_LOADING");
    this.$store.commit("RESET_TOAST");
  },
};
</script>
